import script from "./Selector.vue?vue&type=script&setup=true&lang=js"
export * from "./Selector.vue?vue&type=script&setup=true&lang=js"

import "./Selector.vue?vue&type=style&index=0&id=ecf63294&scoped=true&lang=postcss"

import exportComponent from "/var/www/app.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecf63294"]])

export default __exports__